import {useMemo} from 'react';
import { Field, reduxForm } from "redux-form";
import { Form, Button } from "antd";
import { CreateCheckbox, CreateSelectField, CreateTextField } from "../Helpers/Input/InputCreator";
import { email, required, commaequals } from "../Helpers/Input/validations";
import { connect } from "react-redux";
import importCertificateNetcoCodes from '../../actions/certificates/importCertificateNetcoCodes';
import PrivateRoute from "../Root/PrivateRoute";
import certificates from "../../const/certificates";
import general from "../../const/general";
import { ReactComponent as OtherCertificatesIcon } from '../../resources/img/NewIcons/certificates/other-certificates.svg'
import { getCustomMessages, renderSelectCountry } from '../Helpers/utils';

const CSROption = (props) => {
    const onSubmit = (formValues) => {
        formValues.language = props.language;
        formValues.requiresCert = props.requiresCert;
        props.generateCSR(formValues);
    };
    const requiredLanguage = useMemo(() => required(props.language), [props.language]);
    return (
        <>
            {props.renderCardCertificates(certificates[props.language].createCSR, certificates[props.language].csr_info, OtherCertificatesIcon, certificates[props.language].csr_info3)}
            <Form onFinish={props.handleSubmit(onSubmit)} className={'text-title size12 mt-20'} style={{ marginLeft: 14 }}>
                <div className={'mb-10 mt-10'}>{certificates[props.language].complete_name}</div>
                <Field
                    name="cn"
                    component={CreateTextField}
                    placeholder={certificates[props.language].complete_name}
                    validate={[requiredLanguage, commaequals]}
                    hasFeedback />

                <div className={'mb-10 mt-10'}>{certificates[props.language].email}</div>
                <Field
                    name="mail"
                    component={CreateTextField}
                    placeholder={certificates[props.language].email}
                    validate={[requiredLanguage, email]}
                    hasFeedback />
                <div className={'mb-10  mt-10'}>{certificates[props.language].identification}</div>
                <Field
                    name="cedula"
                    component={CreateTextField}
                    placeholder={certificates[props.language].identification}
                    validate={[requiredLanguage, commaequals]}
                    hasFeedback />
                <div className={'mb-10  mt-10'}>{certificates[props.language].country}</div>
                <Field
                    name="country"
                    component={CreateSelectField}
                    validate={[requiredLanguage]}
                    hasFeedback>
                    {renderSelectCountry()}
                </Field>
                <div className={'mb-10  mt-10'}>{certificates[props.language].department}</div>
                <Field
                    name="state"
                    component={CreateTextField}
                    placeholder={certificates[props.language].department}
                    validate={[requiredLanguage, commaequals]}
                    hasFeedback />

                <div className={'mb-10  mt-10'}>{certificates[props.language].city}</div>
                <Field
                    name="city"
                    component={CreateTextField}
                    placeholder={certificates[props.language].city}
                    validate={[requiredLanguage, commaequals]}
                    hasFeedback />


                <div className={'mb-10 mt-10'}>{certificates[props.language].address}</div>
                <Field
                    name="streetAddress"
                    component={CreateTextField}
                    placeholder={certificates[props.language].address}
                    validate={[requiredLanguage, commaequals]}
                    hasFeedback />

                <div className={'mb-10  mt-10'}>{certificates[props.language].phone}</div>
                <Field
                    name="phone"
                    component={CreateTextField}
                    placeholder={certificates[props.language].phone}
                    validate={[requiredLanguage, commaequals]}
                    hasFeedback />


                <div className={'mb-10  mt-10'}>{certificates[props.language].company_name}</div>
                <Field
                    name="organization"
                    component={CreateTextField}
                    placeholder={certificates[props.language].company_name}
                    validate={[requiredLanguage, commaequals]}
                    hasFeedback />

                <div className={'mb-10  mt-10'}>{certificates[props.language].company_area}</div>
                <Field
                    name="organizationalUnit"
                    component={CreateTextField}
                    placeholder={certificates[props.language].company_area}
                    validate={[requiredLanguage, commaequals]}
                    hasFeedback />
                <Field name="agree"
                    className='mt-20'
                    type={'checkbox'}
                    component={CreateCheckbox}
                    validate={requiredLanguage}
                    hasFeedback>
                    <a rel='noopener noreferrer' target={'_blank'} href={window.netcourlid + '/comagre/AcuerdoDeComunicaciones.pdf'}>
                        {general[props.language].agree}
                    </a>
                </Field>
                <Button htmlType={'submit'} className='mt-20' type={'primary'} style={{ marginRight: 21 }}>
                    {certificates[props.language].createCSR}
                </Button>
                <Button type={'ghost'} onClick={() => props.changeOption(0)}>
                    {certificates[props.language].cancel}
                </Button>
            </Form>
        </>

    );
};

const mapStateToProps = state => {
    const language = state.auth.language;
    return {
        language,
        requiresCert: state.auth.requiresCert,
        initialValues: {
            agree: false,
            country: getCustomMessages(language).messageCountry
        }
    }
};

export default PrivateRoute(connect(mapStateToProps, { importCertificateNetcoCodes })((reduxForm({
    form: 'netcoCertificate_form'
})(CSROption))));

